import { render } from "./DashboardComponent.vue?vue&type=template&id=5654088f&scoped=true"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"

import "./DashboardComponent.vue?vue&type=style&index=0&id=5654088f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5654088f"],['__file',"resources/js/components/admin/dashboard/DashboardComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5654088f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5654088f', __exports__)) {
    api.reload('5654088f', __exports__)
  }
  
  module.hot.accept("./DashboardComponent.vue?vue&type=template&id=5654088f&scoped=true", () => {
    api.rerender('5654088f', render)
  })

}


export default __exports__